import { getJson, putJson, postJson } from '../../utils/network';
import { networkProgress, subscriptionProgress, networkFailed, resetNetwork } from '../../actions';
import { trackEvent, DATAPACKAGE, SIM, TOPUP, NETWORK_SERVICES, BAR_SERVICES, SUCCESS } from '../../utils/analytics';

export const GET_SUBSCRIPTIONS = 'GET_SUBSCRIPTIONS';
export const GET_SUBSCRIPTION_INFO = 'GET_SUBSCRIPTION_INFO';
export const GET_NETWORK_SERVICES = 'GET_NETWORK_SERVICES';
export const GET_DATA_PACKAGES = 'GET_DATA_PACKAGES';
export const GET_SIM_CARD_INFO = 'GET_SIM_CARD_INFO';
export const ORDER_SIM_CARD = 'ORDER_SIM_CARD';
export const ORDER_EXTRA_SIM_CARD = 'ORDER_EXTRA_SIM_CARD';
export const ORDER_TOP_UP = 'ORDER_TOP_UP';
export const ORDER_DATA_PACKAGE_CHANGE = 'ORDER_DATA_PACKAGE_CHANGE';
export const CHANGE_NETWORK_SERVICE = 'CHANGE_NETWORK_SERVICE';
export const GET_SUBSCRIPTION_TASKS = 'GET_SUBSCRIPTION_TASKS';
export const GET_BAR_SERVICES = 'GET_BAR_SERVICES';
export const BAR_SERVICE = 'BAR_SERVICE';

function barServiceSuccess(data) {
   return {
      type: BAR_SERVICE,
      barService: data
   }
}

function getBarServicesSuccess(data) {
   return {
      type: GET_BAR_SERVICES,
      subscription: {
         barServices: data
      }
   }
}

function getSubscriptionTasksSuccess(data) {
   return {
      type: GET_SUBSCRIPTION_TASKS,
      tasks: data
   }
}

function getSimCardInfoSuccess(data) {
   return {
      type: GET_SIM_CARD_INFO,
      subscription: {
         simCardInfo: data
      }
   }
}

function orderSimCardSuccess(data) {
   return {
      type: ORDER_SIM_CARD,
      simCardOrder: data
   }
}

function orderExtraSimCardSuccess(data) {
   return {
      type: ORDER_EXTRA_SIM_CARD,
      extraSimCardOrder: data
   }
}

function topUpOrderSuccess(data) {
   return {
      type: ORDER_TOP_UP,
      topUpOrder: data
   }
}

function dataPackageChangeSuccess(data) {
   return {
      type: ORDER_DATA_PACKAGE_CHANGE,
      dataPackageChange: data
   }
}

function getAvailableDataPackagesSuccess(data) {
   return {
      type: GET_DATA_PACKAGES,
      subscription: {
         dataPackages: data
      }
   }
}

function changeNetworkServiceSuccess(data) {
   return {
      type: CHANGE_NETWORK_SERVICE,
      networkServiceChange: data
   }
}

function getNetworkServicesSuccess(data) {
   return {
      type: GET_NETWORK_SERVICES,
      subscription: {
         networkServices: data
      }
   }
}

function getSubscriptionsSuccess(data) {
   return {
      type: GET_SUBSCRIPTIONS,
      subscriptions: data
   };
}

function getSubscriptionInfoSuccess(data) {
   return {
      type: GET_SUBSCRIPTION_INFO,
      subscription: data
   };
}

export function changeBarService(subscriptionId, id, enabled) {
   var data = {
      id,
      enabled
   };
   return dispatch => {
      dispatch(subscriptionProgress());
      return postJson('/barring/' + subscriptionId, data)
         .then(response => {
            dispatch(barServiceSuccess(response.data));
            dispatch(getBarServices(subscriptionId));
            trackEvent(BAR_SERVICES, SUCCESS);
            dispatch(resetNetwork());
         })
         .catch(error => {
            dispatch(networkFailed(error));
         });
   }
}

export function getSubscriptionIfExists(subscription) {
   return dispatch => {
      if (subscription) {
         dispatch(getSubscriptionInfo(subscription.id));
         dispatch(getSubscriptionTasks(subscription.id));

         if(subscription.netType == 'Mobile' || subscription.netType == 'MobileBroadband') {
            dispatch(getNetworkServices(subscription.id));
            dispatch(getSimCardInfo(subscription.id));
            dispatch(getAvailableDataPackages(subscription.id));
            dispatch(getBarServices(subscription.id));
         }
         else {
            dispatch(getNetworkServicesSuccess(null));
            dispatch(getSimCardInfoSuccess(null));
            dispatch(getAvailableDataPackagesSuccess(null));
            dispatch(getBarServicesSuccess(null));
         }
      }
   }
}

export function getBarServices(subscriptionId) {
   return dispatch => {
      dispatch(networkProgress());
      return getJson('/barring/' + subscriptionId)
         .then(response => {
            dispatch(getBarServicesSuccess(response.data));
            dispatch(resetNetwork());
         })
         .catch(error => {
            dispatch(networkFailed(error));
         })
   }
}

export function getSubscriptionTasks(subscriptionId) {
   return dispatch => {
      dispatch(networkProgress());
      return getJson('/subscriptionTasks/' + subscriptionId)
          .then(response => {
             dispatch(getSubscriptionTasksSuccess(response.data));
             dispatch(resetNetwork());
          })
          .catch(error => {
             dispatch(networkFailed(error));
          })
   }
}

export function getSimCardInfo(subscriptionId) {
   return dispatch => {
      dispatch(networkProgress());
      return getJson('/simCard/' + subscriptionId)
         .then(response => {
            dispatch(getSimCardInfoSuccess(response.data));
            dispatch(resetNetwork());
         })
         .catch(error => {
            dispatch(networkFailed(error));
         });
   };
}

export function orderTopUp(subscriptionId, data) {
   return dispatch => {
      dispatch(subscriptionProgress());
      return postJson('/dataPackages/' + subscriptionId, data)
         .then(response => {
            dispatch(topUpOrderSuccess(response.data));
            trackEvent(TOPUP, SUCCESS);
            dispatch(resetNetwork());
         })
         .catch(error => {
            dispatch(networkFailed(error));
         });
   };
}


export function orderDataPackageChange(subscriptionId, data) {
   return dispatch => {
      dispatch(subscriptionProgress());
      return putJson('/dataPackages/' + subscriptionId, data)
         .then(response => {
            dispatch(dataPackageChangeSuccess(response.data));
            dispatch(getSubscriptionTasks(subscriptionId));
            trackEvent(DATAPACKAGE, SUCCESS);
            dispatch(resetNetwork());
         })
         .catch(error => {
            dispatch(networkFailed(error));
         });
   };
}

export function orderSimCard(subscriptionId, activationTime) {
   var data = {
      activationTime
   };
   return dispatch => {
      dispatch(subscriptionProgress());
      return postJson('/simCard/' + subscriptionId, data)
         .then(response => {
            dispatch(orderSimCardSuccess(response.data));
            dispatch(getSubscriptionTasks(subscriptionId));
            trackEvent(SIM, SUCCESS);
            dispatch(resetNetwork());
         })
         .catch(error => {
            dispatch(networkFailed(error));
         });
   };
}

export function orderExtraSimCard(subscriptionId, activationTime) {
   var data = {
      activationTime
   };
   return dispatch => {
      dispatch(subscriptionProgress());
      return postJson('/extraSimCard/' + subscriptionId, data)
         .then(response => {
            dispatch(orderExtraSimCardSuccess(response.data));
            dispatch(getSubscriptionTasks(subscriptionId));
            trackEvent(SIM, SUCCESS);
            dispatch(resetNetwork());
         })
         .catch(error => {
            dispatch(networkFailed(error));
         });
   };
}

export function activateSimCard(subscriptionId) {
   return dispatch => {
      dispatch(subscriptionProgress());
      return putJson('/simCard/' + subscriptionId)
          .then(response => {
             dispatch(getSubscriptionTasks(subscriptionId));
             dispatch(getSimCardInfo(subscriptionId));
             dispatch(resetNetwork());
          })
          .catch(error => {
             dispatch(networkFailed(error));
          });
   };
}

export function getAvailableDataPackages(subscriptionId) {
   return dispatch => {
      dispatch(networkProgress());
      return getJson('/dataPackages/' + subscriptionId)
         .then(response => {
            dispatch(getAvailableDataPackagesSuccess(response.data));
            dispatch(resetNetwork());
         })
         .catch(error => {
            dispatch(networkFailed(error));
         });
   };
}

export function changeNetworkService(subscriptionId, id, enabled) {
   var data = {
      id,
      enabled
   };
   return dispatch => {
      dispatch(subscriptionProgress());
      return putJson('/networkServices/' + subscriptionId, data)
         .then(response => {
            dispatch(changeNetworkServiceSuccess());
            dispatch(getNetworkServices(subscriptionId));
            trackEvent(NETWORK_SERVICES, SUCCESS);
            dispatch(resetNetwork());
         })
         .catch(error => {
            dispatch(networkFailed(error));
         });
   };
}

export function getNetworkServices(subscriptionId) {
   return dispatch => {
      dispatch(networkProgress());
      return getJson('/networkServices/' + subscriptionId)
         .then(response => {
            dispatch(getNetworkServicesSuccess(response.data));
            dispatch(resetNetwork());
         })
         .catch(error => {
            dispatch(networkFailed(error));
         });
   };
}

export function getSubscriptions() {
   return dispatch => {
      dispatch(networkProgress());
      return getJson('/subscriptions')
         .then(response => {
            dispatch(getSubscriptionsSuccess(response.data));
            dispatch(getSubscriptionIfExists(response.data ? response.data[0] : null));
            dispatch(resetNetwork());
         })
         .catch(error => {
            dispatch(networkFailed(error));
         });
   };
}

export function getSubscriptionInfo(subscriptionId) {
   return dispatch => {
      dispatch(networkProgress());
      return getJson('/subscriptions/' + subscriptionId)
         .then(response => {
            dispatch(getSubscriptionInfoSuccess(response.data));
            dispatch(resetNetwork());
         })
         .catch(error => {
            dispatch(networkFailed(error));
         });
   };
}